"use no memo";

import React from "react";
import "./ShowcaseCoverTab.scss";

import { useSelector } from "react-redux";
import { CoverFooter } from "./components/CoverFooter/CoverFooter";
import { CoverTop } from "./components/CoverTop/CoverTop";
import CoverPlaceholder from "./components/CoverPlaceholder/CoverPlaceholder";
import { CoverSummary } from "./components/CoverSummary/CoverSummary";
import { CoverAudienceOverlap } from "../../../ShowcaseAudienceOverlap/CoverAudienceOverlap";

export function ShowcaseCoverTab(props) {
  const { renderCreators } = props;

  const summaryPlacement = useSelector(
    (state) => state.showcaseReducer.summaryPlacement,
  );

  return (
    <div>
      <CoverTop renderCreators={renderCreators} />
      {summaryPlacement.value === "top" && <CoverSummary />}
      <CoverAudienceOverlap />
      <CoverPlaceholder />
      {summaryPlacement.value === "bottom" && <CoverSummary />}
      <CoverFooter renderCreators={renderCreators} />
    </div>
  );
}
